<script>
    import Header from '../global/header.svelte'
    import Loader from '../widgets/loader.svelte'
    import { onMount } from 'svelte';

    let offers = [];
    let loading = true;

    export let toc_message;

	onMount(async () => {
		const res = await fetch(`https://api.southernco-op.co.uk/offers/get`);
        offers = await res.json();
         if( offers.ok ) {
            loading = false;
        } else {
             loading = false;
        }
        
	});

</script>

<style> 
    article {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(255,255,255,.3);
        padding-bottom: 1em;
        margin-bottom: 1em;
    }
    article > .content {
        flex-basis: 55%;
    }
    .figure {
        
       flex-basis: 40%;
       background: #fff;
       border-radius: 20px;
       display: flex;
       align-items: center;
       justify-content: center;
       padding: 20px;
    }
    .figure img {
        max-height: 121px;
    }
    h2 {
        font-size: 13px;
        font-size: 1.3rem;
        font-weight: 500;
        line-height: 16px;
        line-height: 1.6rem;
    }
    
    small {
        font-size: 12px;
        font-size: 1.2rem;
        opacity: .6;
    }

    @media screen and ( min-width: 600px ) {
        section > div {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
        .offer {
            flex-basis: 48%;
        }


    }

    @media screen and ( min-width: 1000px ) {
         .offer {
            flex-basis: 32%;
        }
    }

    @media screen and ( min-width: 1350px ) {
        .offer {
            flex-basis: 23%;
        }
    }

    .tc {
        text-align: center;
        margin-top: 2em;
    }

    .lead_offer {
        margin-bottom: 2em;
    }
    .lead_offer a {
        text-decoration: underline;
    }
    .lead_offer img {
        width: 100%;
    }
    .lead_offer h2 {
        color: var(--brand-color);
        font-size: 22px;
        font-size: 2.2rem;
        font-weight: 500;
        line-height: 29px;
        line-height: 2.9rem;
    }
    .lead_offer figure {
        margin:0 0 1em 0;
    }
    .laed_offer__tcs {
        font-size: 12px;
        line-height: 16px;
    }


</style>


<svelte:head>
    <title>Offers</title>
</svelte:head>



<Header title="Offers" url="/" /> 

<section>
    <div>

       

        {#if !loading}
            {#if offers.length }
                {#each offers as offer}
                <article class="offer">
                    <div class="figure">
                        <img src={offer.media.medium} alt={offer.title}>
                    </div>
                    <div class="content">
                        <header>
                            <h2>{@html offer.title}</h2>
                        </header>
                        <small>{@html offer.content}</small>
                    </div>
                </article>
                {/each}
                {#if toc_message}
                <div class="tc">View our <a href="https://all-yours.co.uk/offers/#terms">terms & conditions</a></div>
                {/if}
            {:else}
                 <p>No new offers</p>
            {/if}

            

        {:else}
            <Loader msg="Loading offers" />
        {/if}

       
    </div>
</section>
